export default __webpack_public_path__ + "static/unsolvedCaseLogo-9a7eaa01600039b08fa665ad10ba85cb.png";